import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { ColorBoxFilter } from '@vlabs/shared/components/filters-panel/components/color-box-filter/ColorBoxFilter';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';
import st from '../popovers.module.sass';

function UpperAttributesFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { control } = useFormContext();
  const { t } = useSearchPageTranslation();

  return (
    <FilterPopover
      {...props}
      name={['upper_clothing_colors', 'sleeve_lengths']}
      ref={ref}
    >
      <ColorBoxFilter
        control={control}
        isMulti
        label={t('filters.event_filters.body_attributes.upper_colors')}
        name="upper_clothing_colors"
        options={EVENT_ENUMS.UPPER_BODY.UPPER_CLOSING_COLOR.raw}
        showResetButton={false}
      />
      <div className={st.Divider} />
      <div className={st.Subtitle}>{t('filters.event_filters.body_attributes.sleeve')}</div>
      <div className={st.CheckboxContainer}>
        <ControllableOptionsFilter
          control={control}
          isSearchable={false}
          name="sleeve_lengths"
          options={EVENT_ENUMS.UPPER_BODY.SLEEVE.raw}
        />
      </div>
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const UpperAttributesFilterPopoverWithRef = forwardRef(UpperAttributesFilterPopover);
export { UpperAttributesFilterPopoverWithRef as UpperAttributesFilterPopover };
